import { render, staticRenderFns } from "./createStudentClassWork.vue?vue&type=template&id=73539fbe&scoped=true"
import script from "./createStudentClassWork.vue?vue&type=script&lang=js"
export * from "./createStudentClassWork.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./createStudentClassWork.vue?vue&type=style&index=1&id=73539fbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73539fbe",
  null
  
)

export default component.exports